import ReceiptProtocolGenerator from './ReceiptProtocolGenerator';

export default ReceiptProtocolGenerator;